module.exports = __webpack_public_path__ + "img/img_05.19cc6f7f.webp";